import Geo4Dbackground from './images/background/background_geo4d.jpg';
import Geo4Dlogo from './images/logo/logo_geo4d.jpg';
import defaultBackground from './images/background/backgroundVideo.mp4';
import defaultLogoDark from './images/logo/dronLogoBlue.png';
import defaultLogoWhite from './images/logo/dronLogo.png';
import defaultCompanyLogo from './images/logo/gisonline.png'

export const isLiveFake = false;
export const RECAPTCHA_SITE_KEY = '6LehVF4UAAAAAGw_FZp-M7TfgjRtCpxcxU_ZbzlJ';
export const missionPhotoLimit = 0;
export const version = '1.10.1';
export const GOOGLE_ANALYTICS_CODE = "UA-138963338-1";
export const mainAddress = "Królewska 57 30-081 Kraków";
export const domainProperties = new Map([
    ['geo-4d.gisonline.pl', {
        BASE_URL: 'https://geo-4d.gisonline.pl/drononline/api/',
        //BASE_URL: 'https://geo-4d.gisonline.pl/drononline/api-test/',
        //BASE_URL: "http://localhost:50347/",
        appName: 'Geo-4D Portal',
        versionVisible: false,
        oneLanguage: 'en',
        backgroundType: 'image',
        background: Geo4Dbackground,
        darkLogo: Geo4Dlogo,
        whiteLogo: Geo4Dlogo,
        companyName: 'Geo-4D',
        address: [],
        phones: ['+44 (0)345 257 0877'],
        mail: 'info@geo-4d.com',
        website: 'https://www.geo-4d.com/',
        companyLogo: Geo4Dlogo,
        hasBathyMap: true,
        registerGuestAllowed: false
    }],
    ['www.drononline.gisonline.pl', {
        BASE_URL: "https://www.drononline.gisonline.pl/drononline/api/",
        //BASE_URL: "https://www.drononline.gisonline.pl/drononline/api-test/",
        //BASE_URL: "http://localhost:50347/",
        appName: 'DRONonLine',
        versionVisible: true,
        oneLanguage: undefined,
        backgroundType: 'video',
        background: defaultBackground,
        darkLogo: defaultLogoDark,
        whiteLogo: defaultLogoWhite,
        companyName: 'GISonLine Sp. z o.o. Sp. k.',
        address: ['ul. Królewska 57', '30-081 Kraków'],
        phones: [],
        mail: 'drononline@gisonline.pl',
        website: 'http://www.gisonline.pl',
        companyLogo: defaultCompanyLogo,
        hasBathyMap: false,
        registerGuestAllowed: true
    }]
]);



// WEBPACK FOOTER //
// ./src/config.js